import { authFetch } from "@/lib/api-client";

export interface RetoolEmbedUrlResponse {
  embedUrl: string;
}

export async function fetchRetoolEmbedUrl(tenantId: string): Promise<RetoolEmbedUrlResponse> {
  const { data } = await authFetch<RetoolEmbedUrlResponse>(
    `/workspace/embed-url?tenantId=${encodeURIComponent(tenantId)}`,
  );
  return data;
}
